import type { InsuranceOffer } from '@backmarket/http-api/src/api-models/InsuranceOffer'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { VariantsEnum as TagVariants } from '@ds/components/Tag/Tag.constant'

import translations from './useInsuranceTagProps.translations'

export function useInsuranceTagProps(offers: InsuranceOffer[], index: number) {
  const i18n = useI18n()

  if (index === 0)
    return {
      label: i18n(translations.recommendedTag),
      variant: TagVariants.Primary,
    }

  return undefined
}
